import { storageKey, userRole } from "../../../constants/constants";
import { LocalStorageService } from "../../../services/LocalStorage";

export const isLoggedIn = (): boolean => {
    const userData: any = LocalStorageService.getItem(storageKey.user_data);
    return ((userData?.access_token && userData?.role === userRole.product));
};